import { erpAxios } from '.';

const insertEvent = async (data) => {
  const res = await erpAxios.post(`/gpsDogadjaji/event`, data);
  return res;
};

export default insertEvent;
